module.exports = __webpack_public_path__ + "static/media/St_VS_BnH_V.aaea45bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/St_VS_BnH_V.png
// module id = 93
// module chunks = 0